/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Stringendsaspect6Inputs */

const de__class_stringendsaspect6 = /** @type {(inputs: _Class_Stringendsaspect6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`endet mit`)
};

/**

* @param {_Class_Stringendsaspect6Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_stringendsaspect6 = /** @type {((inputs?: _Class_Stringendsaspect6Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Stringendsaspect6Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_stringendsaspect6(inputs)
});
export { _class_stringendsaspect6 as "_class_StringENDSAspect" }